import React, { useCallback, useEffect } from 'react';
import { InputProps } from '@material-ui/core/Input';
import debounce from 'debounce';
import { useDispatch, useSelector } from 'react-redux';
import { FormHelperText } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { ReactFormInput } from '..';
import {
  clearValidationPromotionCodeWIthProduct,
  validatePromotionCodeWithProductRequest,
} from '../../store/modules/promotion-codes/actions';
import { selectVerifiedCode } from '../../store/modules/promotion-codes/selectors';
import StatusIcon from '../password-error/StatusIcon';
import useStyles from './styles';
import InlineDots from './InlineDots';

type Props = Omit<InputProps, 'classes'> & {
  label?: string;
  name: string;
  autoCheck?: boolean;
};

const ReactFormPromotionCodeInput = ({
  name,
  label,
  autoCheck = false,
}: Props) => {
  const { getValues } = useFormContext();
  const dispatch = useDispatch();
  const { [name]: value } = getValues();
  const { data: promoCode, loading, error } = useSelector(selectVerifiedCode);
  const classes = useStyles();

  useEffect(() => {
    dispatch(clearValidationPromotionCodeWIthProduct());
  }, [dispatch]);

  const checkPromotionCode = useCallback((code: string) => {
    if (autoCheck) {
      if (code && code.length > 7) {
        dispatch(validatePromotionCodeWithProductRequest(code));
      } else {
        dispatch(clearValidationPromotionCodeWIthProduct());
      }
    }
  }, [dispatch, autoCheck]);

  const checkPromotionCodeHandler = useCallback(debounce((search: string) => { checkPromotionCode(search); }, 1500),
    [checkPromotionCode]);

  useEffect(() => {
    checkPromotionCodeHandler(value);
  }, [value, checkPromotionCodeHandler]);

  return (
    <div>
      <ReactFormInput
        className={classes.uppercaseField}
        label={label}
        name={name}
        hideErrors
      />
      {loading && <FormHelperText>Verifying<InlineDots/></FormHelperText>}
      {error && (
        <FormHelperText className={`${classes.helperText} ${classes.helperTextError}`}>
          <StatusIcon state={false} className={classes.icon} />
          Sorry, this Promo Code is not valid
        </FormHelperText>
      )}
      {promoCode && !loading && (
        <FormHelperText className={`${classes.helperText} ${classes.helperTextSuccess}`}>
          <StatusIcon state className={classes.icon} />
          Promo Code accepted for {promoCode.summary}
        </FormHelperText>
      )}
    </div>
  );
};

export default ReactFormPromotionCodeInput;
